import { Box, Typography } from '@mui/material';
import { TournamentEntity } from 'app/interfaces/entity';
import { TournamentStatus } from 'modules/tournaments/components/TournamentStatus';
import { TournamentStatusViewType } from 'modules/tournaments/enums';
import React, { FC } from 'react';
import { GameCurrencyWithFee } from 'modules/game-payments/components';
import { useStyles } from './TournamentModalHeader.styles';

interface TournamentModalHeaderProps {
  tournament: TournamentEntity;
}

export const TournamentModalHeader: FC<TournamentModalHeaderProps> = ({ tournament }) => {
  const { classes } = useStyles();

  const entryFee = tournament?.prizeAndDistribution?.playerEntryFee ?? 0;

  return (
    <Box className={classes.root}>
      <Box className={classes.gameDetails}>
        <Box className={classes.logoContainer}>
          <img className={classes.logo} src={tournament?.game?.icon} alt="game-logo" />
        </Box>
        <Box className={classes.descriptionContainer}>
          <Typography className={classes.title}>{tournament.name}</Typography>
          <Typography className={classes.description}>
            Standard •&nbsp;
            <GameCurrencyWithFee amount={entryFee} showZeroLabel={true} />
          </Typography>
        </Box>
      </Box>
      <Box className={classes.statusContainer}>
        <TournamentStatus tournament={tournament} viewType={TournamentStatusViewType.Header} />
      </Box>
    </Box>
  );
};
